import { ApiHroadsGender } from './hroads-gender.api';

/**
 * Gender
 */
export enum Gender {
  lady = 'lady',
  man = 'man'
}

/**
 * Map a gender from the Hroads API to a gender
 *
 * @param hroadsGender The gender from the Hroads API
 * @returns The gender
 */
export const hroadsGenderToGender = (hroadsGender: ApiHroadsGender): Gender => {
  switch (hroadsGender) {
    case ApiHroadsGender.Lady:
    case ApiHroadsGender.LadyNotSure:
      return Gender.lady;
    default:
      return Gender.man;
  }
};
